import { SourceService } from '@app/core/services/source.service';
import { Transaction } from '../transaction';
import { Meta } from '@app/core/resources/meta';
import { TransactionPrivate } from '@app/core/resources/transaction-private';
import { ServiceLoader } from '@app/core/services/service-loader';
import { marketingMetas } from './marketing-metas';
import { MetasTransactionEnum } from '@app/core/enums/metas.enum';

export class MetaTransactionsHelper {
    public sourceService: SourceService;

    public constructor(public transaction: Transaction | TransactionPrivate) {
        this.sourceService = ServiceLoader.injector.get(SourceService);
        this.transaction.relationships.metas.data = [];
    }

    private addMarketingMetasToTransaction(): void {
        marketingMetas.forEach((meta: any) => {
            let metaUtm: string | null = this.sourceService.getUtm(meta.metaName);
            if (!metaUtm) {
                return;
            }

            this.createAndAddMetaToTransaction(meta.metaId, meta.metaKey, metaUtm);
        });
    }

    public addMetasToTransaction(): void {
        this.addMarketingMetasToTransaction();
        this.addAgentMetasToTransaction();
    }

    private addAgentMetasToTransaction(): void {
        this.createAndAddMetaToTransaction('new_21', MetasTransactionEnum.AGENT, navigator.userAgent);
    }

    public addViaMetasToTransaction(via: string): void {
        this.createAndAddMetaToTransaction('new_22', MetasTransactionEnum.VIA, via);
    }

    public addPublicObservationsToTransaction(public_observation: string): void {
        this.createAndAddMetaToTransaction('new_20', MetasTransactionEnum.PUBLIC_OBSERVATION, public_observation);
    }

    private createAndAddMetaToTransaction(id: string, key: string, value: string): void {
        let meta: Meta = new Meta();
        meta.id = id;
        meta.attributes.key = key;
        meta.attributes.value = value;
        this.transaction.addRelationship(meta, 'metas');
    }

    public clearMetas(): void {
        this.transaction.relationships.metas.data = [];
    }
}
